import { useEffect, useRef } from "react";

import usePageVisible from "@helpers/hooks/use-page-visible";

import { meetingPageRefreshInterval } from "./meeting-page";

const MeetingPageVisibilityRefreshDetection = ({
  refetch,
}: {
  refetch: () => void;
}) => {
  const lastTimeVisible = useRef<number>(Date.now());
  const isPageVisible = usePageVisible();

  // detect if meeting page needs to be refreshed
  useEffect(() => {
    if (isPageVisible) {
      if (lastTimeVisible.current + meetingPageRefreshInterval < Date.now()) {
        // if page was not visible for more than 5 minutes we force a refresh
        refetch();
      }
      lastTimeVisible.current = Date.now();
    }
  }, [refetch, isPageVisible]);
  return null;
};

export default MeetingPageVisibilityRefreshDetection;
